import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  margin: 0 -24px;
  padding: var(--spacing-space-32, 32px) var(--spacing-space-24, 24px)
    var(--spacing-space-24, 24px);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-space-32, 32px);

  border-radius: var(--rounding-radius-xxxl, 48px);
  background: var(--fill-elevated, #fff);

  box-shadow: 0 8px 24px 0 rgba(51, 20, 0, 0.08),
    0 4px 8px 0 rgba(51, 20, 0, 0.04);

  @media (min-width: 1024px) {
    flex-direction: row;
    max-width: 842px;
    margin: 0 auto;
    padding: var(--spacing-space-24, 24px) var(--spacing-space-24, 24px)
      var(--spacing-space-24, 24px) var(--spacing-space-48, 48px);
    gap: var(--spacing-space-32, 48px);
  }
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  text-align: center;
  justify-content: space-between;

  @media (min-width: 1024px) {
    align-items: flex-start;
    text-align: left;

    .title-container {
      width: 226px;
    }
  }

  .subheader {
    color: var(--text-secondary, rgba(66, 61, 60, 0.64));
  }
`;

export const RafflesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: right;
  gap: var(--spacing-space-16, 16px);
  flex-grow: 1;
`;

const counterWithWinners = css`
  display: flex;
  height: 32px;
  padding: 0 var(--spacing-space-12, 12px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-space-4, 4px);

  border-radius: var(--rounding-radius-m, 16px);
  background: var(--fill-elevated, #fff);

  box-shadow: 0 4px 8px 0 rgba(51, 20, 0, 0.08),
    0 2px 1px 0 rgba(51, 20, 0, 0.04);

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 125% */
  letter-spacing: 0.48px;
`;

const timerCounter = css`
  display: flex;
  min-width: 32px;
  padding: var(--spacing-space-4, 4px) var(--spacing-space-12, 12px)
    var(--spacing-space-4, 4px) var(--spacing-space-4, 4px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-space-4, 4px);

  border-radius: var(--rounding-radius-m, 16px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  backdrop-filter: blur(12px);
`;

export const RaffleCard = styled.div<{ $withWinners?: boolean }>`
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  padding: var(--spacing-space-16, 16px) var(--spacing-space-24, 24px);

  border-radius: var(--rounding-radius-xl, 24px);
  background-color: ${({ $withWinners }) =>
    $withWinners
      ? `var(--fill-accent-secondary, rgba(50, 250, 220, 0.16))`
      : `var(--fill-secondary, rgba(204, 187, 184, 0.16));`};

  ${({ $withWinners }) => $withWinners && `cursor: pointer`};

  @media (min-width: 1024px) {
    width: 372px;
    align-self: flex-end;
  }

  .counter {
    ${({ $withWinners }) => ($withWinners ? counterWithWinners : timerCounter)}
  }
`;

export const YourTickets = styled.div`
  display: inline-flex;
  height: 48px;
  margin: 32px 0 0;
  padding: 0 var(--spacing-space-24, 24px) 0 var(--spacing-space-16, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-space-8, 8px);

  border-radius: var(--rounding-radius-xs, 8px);
  background: var(--fill-accent-primary, #9fe);

  cursor: pointer;

  @media (min-width: 1024px) {
    margin: 0 0 24px;
  }
`;
